module.exports = __webpack_public_path__ + "static/media/background.a3b4a99c.jpg";